import { useExamCourse } from '@exam-center/admin-exam-course-details';
import { NavigateBackLink } from '@exam-center/components';
import {
  EXAM_COURSE_LANGUAGE_TEXT,
  EXAM_COURSE_TYPE_TEXT,
} from '@exam-center/exam-course-management';
import { EllipsisText, Flex, Loading, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';
import { Navigate, Outlet } from 'react-router-dom';

export default function AdminExamCourseDetailsLayout() {
  const { examCourse, loading: isLoading, error } = useExamCourse();

  if (isLoading) {
    return <Loading sx={{ height: '100dvh' }} />;
  } else if (error || !examCourse) {
    // TODO: Use error boundary
    return <Navigate to='/not-found' replace />;
  }

  const { name, examId, type, language, updatedAt } = examCourse;

  return (
    <>
      <PageHeader
        title={name}
        linkAdornment={<NavigateBackLink to='/admin/exam-courses' />}
        subtitleSection={
          <Flex
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              color: (theme) => theme.palette.text.secondary,
            }}
          >
            <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
              <EllipsisText variant='body2'>{`Exam ID: ${examId}`}</EllipsisText>
              <EllipsisText variant='body2'>{`Course Type: ${EXAM_COURSE_TYPE_TEXT[type]}`}</EllipsisText>
              <EllipsisText variant='body2'>{`Course Language: ${EXAM_COURSE_LANGUAGE_TEXT[language]}`}</EllipsisText>
            </Flex>
            <Text variant='body2'>{`Last Modified: ${formatDateTime(updatedAt)}`}</Text>
          </Flex>
        }
      />
      <Outlet />
    </>
  );
}
